module.exports = __webpack_public_path__ + "img/aboutUs_img12.1dceac37.svg";